class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const urlParams = new URLSearchParams(this.dataset.productUrl.split('?')[1] || '');
    const variantId = urlParams.get('variant');
    
    let sectionUrl = `${productUrl}?view=modal`;
    if (variantId) {
      sectionUrl += `&variant=${variantId}`;
    }

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);



          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl,
              variantId: variantId
            }
          }));

          // Select the variant after the modal is fully loaded
          if (variantId) {
            this.selectVariant(variantId);
          }
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  selectVariant(variantId) {
    // Wait for variant options to be rendered
    const waitForVariants = () => {
      const variantSelects = this.querySelector('variant-selects');
      if (variantSelects) {
        // Check if variant options are rendered
        const optionInputs = variantSelects.querySelectorAll('input[value]');
        
        if (optionInputs.length > 0) {
          // Variants are rendered, now try to select
          this.selectVariantNow(variantId);
        } else {
          // Variants not yet rendered, wait and try again
          setTimeout(waitForVariants, 200);
        }
      } else {
        // No variant-selects found, try other methods
        this.selectVariantNow(variantId);
      }
    };
    
    waitForVariants();
  }
  
  selectVariantNow(variantId) {
    // Try multiple approaches to find and select the variant
    
    // 1. Look for variant-selects component specifically
    const variantSelects = this.querySelector('variant-selects');
    if (variantSelects) {
      // Try to find the specific option within the variant-selects
      // First try by data-option-value-id (which contains the actual variant ID)
      let optionInput = variantSelects.querySelector(`input[data-option-value-id="${variantId}"]`);
      
      if (!optionInput) {
        // Fallback to value attribute
        optionInput = variantSelects.querySelector(`input[value="${variantId}"]`);
      }
      
      if (optionInput) {
        optionInput.checked = true;
        optionInput.click();
        
        // Also trigger change event
        setTimeout(() => {
          optionInput.dispatchEvent(new Event('change', { bubbles: true }));
          optionInput.dispatchEvent(new Event('input', { bubbles: true }));
        }, 100);
        return;
      }
      
      // If no direct input found, try to trigger on the variant-selects component
      if (variantSelects.onVariantChange) {
        variantSelects.onVariantChange({ target: { value: variantId } });
      }
    }
    
    // 2. Look for any input with the variant ID
    const variantInput = this.querySelector(`input[value="${variantId}"], input[data-variant-id="${variantId}"]`);
    if (variantInput) {
      variantInput.checked = true;
      variantInput.click();
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    
    // 3. Look for select elements
    const selectElements = this.querySelectorAll('select[name*="variant"], select[name*="id"]');
    selectElements.forEach(select => {
      if (select.value !== variantId) {
        select.value = variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // 4. Try to trigger on the product-info element
    const productInfo = this.querySelector('product-info');
    if (productInfo) {
      // Try to set the variant directly
      if (productInfo.setVariant) {
        productInfo.setVariant(variantId);
      }
      // Or trigger a custom event
      productInfo.dispatchEvent(new CustomEvent('variant:change', { 
        detail: { variantId: variantId } 
      }));
    }
    
    // 5. Look for any elements with data-variant-id
    const variantElements = this.querySelectorAll(`[data-variant-id="${variantId}"]`);
    variantElements.forEach(element => {
      element.click();
    });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
